import React, { useState } from 'react'
import styled from 'styled-components'
import { CSSTransition } from 'react-transition-group'
import { animated, Spring } from 'react-spring/renderprops'

import { FlexColumnCenter } from 'Components/layout'
import { Button } from 'Components/input'
import { Panel, RichTextDisplay } from 'Components/readonly'

const WrapperPanel = styled(Panel)`
  &&& {
    padding: 10px 20px 0 20px;
    margin-bottom: 5px;
    position: relative;
    cursor: pointer;

    h3 {
      padding-right: 30px;
    }
  }
`

const ToggleButton = styled(Button)`
  & {
    margin: 0 !important;
  }
`

const ToggleText = styled.p`
  margin: 0;
  min-height: 50px;
`

const ToggleTextContainer = styled.div`
  .item {
    overflow: hidden;
  }
`

const CloseButton = styled(Button)`
  position: absolute;
  top: 3px;
  right: 0;
`

export const DynamicMessage = ({ message, onDelete }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <CSSTransition in={true} timeout={200} classNames="fade" unmountOnExit={true} appear={true}>
      <WrapperPanel
        dark
        onClick={(e) => {
          setIsOpen(!isOpen)
          e.preventDefault()
          e.stopPropagation()
        }}>

        <CloseButton
          className="deleteMessage"
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            onDelete(message) // Låt StartPage hantera modal + API + state
          }}
          icon="pi pi-times"
        />

        <h3 style={{ paddingTop: '0' }}>{message.heading}</h3>

        <Spring
          native
          force
          config={{ tension: 1500, friction: 100, precision: 1 }}
          from={{ height: isOpen ? 50 : 'auto' }}
          to={{ height: isOpen ? 'auto' : 50 }}>
          {(props) => (
            <ToggleTextContainer>
              <animated.div className="item" style={props}>
                <ToggleText>
                  <RichTextDisplay value={message.message} />
                </ToggleText>
              </animated.div>
            </ToggleTextContainer>
          )}
        </Spring>

        <FlexColumnCenter>
          <ToggleButton
            className="toggleMore"
            icon={'pi pi-chevron-' + (isOpen ? 'up' : 'down')}
            fill
          />
        </FlexColumnCenter>
      </WrapperPanel>
    </CSSTransition>
  )
}
